import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { navigate } from 'gatsby';
import * as Yup from 'yup';
import Checkbox from 'components/_shared/ContactForm/components/Checkbox/Checkbox';
import Input from 'components/_shared/ContactForm/components/Input/Input';
import Textarea from 'components/_shared/ContactForm/components/Textarea/Textarea';
import Button from 'components/_shared/Button/Button';
import contactFromService from 'services/contactForm';
import { StyledWrapper, StyledForm, StyledTitle } from './ContactForm.styled';

const ContactForm = ({ title }) => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Proszę podać poprawny adres email.').required('To pole jest wymagane.'),
    name: Yup.string()
      .min(2, 'Imię powinno zawierać co najmniej 2 znaki.')
      .max(50, 'Imię powinno zawierać maksymalnie 50 znaków.')
      .required('To pole jest wymagane.'),
    agreement: Yup.bool().oneOf([true], 'To pole jest wymagane.'),
    message: Yup.string().min(2, 'Wiadomość powinna zawierać co najmniej 2 znaki.').required('To pole jest wymagane.'),
  });

  const initialValues = {
    email: '',
    name: '',
    message: '',
    agreement: false,
  };

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);

    contactFromService
      .sendContactForm(values)
      .then(() => {
        navigate('/dziekujemy');
      })
      .catch(() => {
        setSubmitting(true);
      });
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setTouched } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <StyledWrapper>
      <StyledTitle>{title}</StyledTitle>
      <StyledForm onSubmit={handleSubmit}>
        <Input
          theme="dark"
          name="name"
          label="Wpisz swoje imię"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          success={!errors.name && !!values.name}
          errorMessage={errors.name && touched.name && errors.name}
          required
        />
        <Input
          theme="dark"
          name="email"
          label="Wpisz swój email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          success={!errors.email && !!values.email}
          errorMessage={errors.email && touched.email && errors.email}
          required
        />
        <Textarea
          theme="dark"
          name="message"
          label="Treść zapytania"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.message}
          success={!errors.message && !!values.message}
          errorMessage={errors.message && touched.message && errors.message}
          required
        />
        <Checkbox
          label="Wyrażam zgodę na otrzymywanie informacji handlowych drogą elektroniczną na podany powyżej adres poczty elektronicznej wysyłanych przez Biuro Rachunkowe Hossa."
          name="agreement"
          specificClass="agreement"
          onChange={handleChange}
          onBlur={handleBlur}
          checked={values.agreement}
          success={!errors.agreement && !!values.agreement}
          errorMessage={errors.agreement && touched.agreement && errors.agreement}
          required
        />
        <Button
          type="submit"
          disabled={isSubmitting}
          onClick={() =>
            setTouched({
              messageContext: true,
              email: true,
              name: true,
              lastname: true,
              message: true,
              agreement: true,
            })
          }
        >
          WYŚLIJ
        </Button>
      </StyledForm>
    </StyledWrapper>
  );
};

ContactForm.propTypes = {
  title: PropTypes.string,
};

ContactForm.defaultProps = {
  title: 'Wyślij nam wiadomość',
};

export default ContactForm;
